import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const createAppointmentAdmin = async ({ userRoleUuid, payload }) =>
    api.post('/appointments/admin', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const updateAppointmentAdmin = async ({ userRoleUuid, payload }) =>
    api.patch('/appointments/admin', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const listAppointments = async ({
    userRoleUuid,
    appointmentTypes,
    appointmentStatuses,
    queryTs,
    clinicianUuid,
    caregiverUuid,
    order,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/appointments', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(Array.isArray(appointmentTypes) && appointmentTypes.length > 0
                ? { 'CVP-QUERY-APPOINTMENT-TYPE': JSON.stringify(appointmentTypes) }
                : {}),
            ...(Array.isArray(appointmentStatuses) && appointmentStatuses.length > 0
                ? { 'CVP-QUERY-APPOINTMENT-STATUS': JSON.stringify(appointmentStatuses) }
                : {}),
            ...(queryTs ? { 'CVP-QUERY-TIMESTAMP': queryTs } : {}),
            ...(clinicianUuid ? { 'CVP-QUERY-CLINICIAN': clinicianUuid } : {}),
            ...(caregiverUuid ? { 'CVP-QUERY-CAREGIVER': caregiverUuid } : {}),
            ...(order ? { 'CVP-QUERY-ORDER': order } : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {})
        }
    });

export const fetchAppointment = async ({ userRoleUuid, appointmentUuid } = {}) =>
    api.post(
        '/appointments/fetch',
        { appointment: appointmentUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );
